import InitProvider from './Contexts/InitProvider';
import RouteHandler from './RouteHandler';
import MenuProvider from './features/Menus/MenuProvider';
import TemplateProvider from './features/template/TemplateProvider';
import ComposeProviders from './utils/ComposeProviders';

import 'flatpickr/dist/themes/light.css';
import '../assets/style.css';
import AuthProvider from './Contexts/AuthProvider';

function App() {
    return (
        <ComposeProviders components={[TemplateProvider, InitProvider, AuthProvider, MenuProvider]}>
            <RouteHandler />
        </ComposeProviders>
    );
}

export default App;
